<template>
  <dropdown
    placement="top-start"
    no-padding
    :offset="0"
    :disabled="!isIndexesLoaded"
  >
    <template #button>
      <button type="button" class="btn btn-category-dropdown width--100per d-flex justify-content-between align-items-center"
        data-toggle="dropdown"
        :disabled="!isIndexesLoaded"
      >
        <span>{{ getIndexAsString(state.index) }}</span>
        <i class="ml-3 fa fa-angle-down" />
      </button>
    </template>

    <template v-for="item in sortedIndexes">
      <component
        :is="'router-link'"
        class="btn link-button"
        :key="item.name"
        :to="getCategoryLink(item.name)"
      >
        <i :class="`fa fa-check t-primary ${item.name !== state.index && 'invisible' || ''}`" />
        <span class="pl-2 text-center category-list-name">{{ getIndexAsString(item.name) }}</span>
        <span v-if="item.total > 0" class="t-xs t-secondary ml-1 mr-2 mt-1">{{ item.total | formatNumberShort }}</span>
      </component>
    </template>

  </dropdown>
</template>

<script>
import Dropdown from '@/components/shared/form/Dropdown'
import { getCategoryLink } from '@/plugins/utils'

export default {
  name: 'searchCategory',
  components: {
    Dropdown
  },
  props: {
    isIndexesLoaded: {
      type: Boolean,
      required: true
    },
    indexes: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    sortedIndexes () {
      return (this.isIndexesLoaded && this.sortIndexes(this.indexes)) || []
    }
  },
  methods: {
    getCategoryLink (category) {
      return getCategoryLink(this.searchView(category), this.$route, category)
    },
    sortIndexes (results) {
      let sortable = []
      for (let key in results) {
        const res = { ...results[key] }
        res.name = key
        sortable.push(res)
      }
      sortable.sort((a, b) => a.order - b.order)

      return sortable
    }
  }
}
</script>
